import { all, call } from 'redux-saga/effects';
import persistenceSaga from '../redux/coilConfigurator/persistence/saga';
import catalogueSaga from '../redux/coilConfigurator/catalogue/saga';
import assumptionsSaga from '../redux/coilConfigurator/assumptions/saga';
import measurementsSaga from '../redux/coilConfigurator/measurements/saga';
import configurationsSaga from '../redux/coilConfigurator/configurations/saga';
import glossarySaga from '../redux/coilConfigurator/glossary/saga';

export default function* coilConfiguratorSagas() {
  yield all([
    call(persistenceSaga),
    call(catalogueSaga),
    call(assumptionsSaga),
    call(measurementsSaga),
    call(configurationsSaga),
    call(glossarySaga),
  ]);
}
